// import React from "react";
// import ContactForm from "../contact/contact";
// import { Link } from "react-router-dom";

export default function LaunchSection() {
  return (
    <section className="bg-mint-glass py-16 px-6 text-center">
      <div className="max-w-4xl mx-auto">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Launch Surveys. Get Real Insights.
        </h1>

        {/* Subtitle */}
        <div className="max-w-2xl mx-auto">
          <p className="text-gray-600 text-base pt-4 md:text-lg mb-8">
            SurveysIQ connects your business with 10K+ engaged users ready to
            share honest feedback. Make data-driven decisions with confidence.
          </p>
        </div>
        {/* CTA Button */}
        <button
          onClick={() => {
            document
              .getElementById("contact-form")
              .scrollIntoView({ behavior: "smooth" });
          }}
          className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-xl shadow-md font-medium transition"
        >
          Sign Up as a Company
        </button>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12 text-center">
          <div>
            <p className="text-2xl font-bold text-green-600">10K+</p>
            <p className="text-gray-600 text-sm">Active Users</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-green-600">98%</p>
            <p className="text-gray-600 text-sm">Response Rate</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-green-600">24h</p>
            <p className="text-gray-600 text-sm">Avg. Completion</p>
          </div>
        </div>
      </div>
    </section>
  );
}
